// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"a734b837","90":"ef2be9ef","123":"2bff6a19","753":"371b29cd","910":"64818b81","974":"4e335bc1"}[chunkId] + ".css";
};